import { createContext, useContext } from 'react';
import { NInPersonEventActivity } from 'redux/schemas/models/in-person-event';

export type InPersonEventContextType = {
  inPersonEvent: NInPersonEventActivity | null;
  catalogId: string;
  isEdit: boolean;
  isAdmin: boolean;
  sessionId: number | null;
};

export const InPersonEventContext = createContext<InPersonEventContextType | null>(null);

export const useInPersonEventContext = () => {
  const context = useContext(InPersonEventContext);
  if (!context) {
    throw new Error('useInPersonEventContext must be used within InPersonEventProvider');
  }
  return context;
};
